// extracted by mini-css-extract-plugin
export default {"used_search_input":"Customers_used_search_input__uNgEm","heading":"Customers_heading__jqioQ"};